import React from 'react';
import { motion } from 'framer-motion';
import { Minus } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-warm-gray py-16 px-6 md:py-24" data-id="element-137">
      <div className="max-w-reading mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 font-serif" data-id="element-140">
            If you're waking up 2, 3, 4 times a night…
          </h2>
          <p className="text-xl text-charcoal/80 mb-10 font-serif italic" data-id="element-141">
            You already know what it costs.
          </p>

          <ul className="space-y-6 mb-12" data-id="element-142">
            {["You're tired in the morning no matter how early you went to bed.", 'Your patience is shorter. Your mood is thinner.', 'You hesitate on trips, long drives, nights away from home.', 'You start to feel older than you want to feel.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-143">
                <div className="mt-2 text-sage" data-id="element-144">
                  <Minus className="w-6 h-6" data-id="element-145" />
                </div>
                <span className="text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-146">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="bg-white/50 p-8 rounded-lg border-l-4 border-sage" data-id="element-147">
            <p className="text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-148">
              And because it's "bathroom stuff," it stays private.
              <br data-id="element-149" />
              You don't make a big speech about it.
              <br data-id="element-150" />
              You just quietly suffer through it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}